import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const differenceAnimation = () => {
  if (!document.querySelector('.difference__anm')) return;

  gsap.timeline({
    scrollTrigger: {
      trigger: '.difference__anm',
      start: 'top 80%',
      toggleActions: 'play none none none',
    },
  })
    .to('.difference__note', { filter: 'blur(0px)', duration: 1 })
    .to('.difference__deco--1', { opacity: 1, duration: 0.4 })
    .to('.difference__figure--main', { opacity: 1, duration: 0.4 })
    .to('.difference__figure--sub2', { opacity: 1, duration: 0.4 })
    .to('.difference__figure--sub1', { opacity: 1, duration: 0.4 })
    .to('.difference__deco--2', { opacity: 1, duration: 0.4 }, '<');
};

const digitalAnimation = () => {
  const head = document.querySelector('.digital__head');
  const steps = document.querySelectorAll('.digital__step');
  if (!steps.length) return;

  const mm = gsap.matchMedia();

  mm.add('(min-width: 1024px)', () => {
    ScrollTrigger.create({
      trigger: head,
      pin: true,
      start: 'top top',
      endTrigger: steps[2],
      end: 'top 240px',
      pinSpacing: false,
    });

    steps.forEach((step) => {
      ScrollTrigger.create({
        trigger: step,
        start: 'top max(240px, 30%)',
        toggleClass: { targets: step, className: 'is-shown' },
      });
      ScrollTrigger.create({
        trigger: step,
        start: 'top max(240px, 30%)',
        once: true,
        toggleClass: { targets: step, className: 'is-animation-started' },
      });
    });
  });

  mm.add('(max-width: 1023px)', () => {
    steps.forEach((step) => {
      ScrollTrigger.create({
        trigger: step,
        start: 'top 80px',
        once: true,
        toggleClass: { targets: step, className: 'is-shown' },
      });
    });
  });
};

const pageTopLInk = () => {
  const pageTopLink = document.querySelector('.page-top');
  const contactSection = document.getElementById('contact');
  ScrollTrigger.create({
    trigger: contactSection,
    start: 'bottom bottom',
    onEnter: () => {
      pageTopLink.classList.add('is-stopped');
    },
    onLeaveBack: () => {
      pageTopLink.classList.remove('is-stopped');
    },
  })

}

const footerAnimation = () => {
  const footer = document.querySelector('.site-footer');
  const contact = document.getElementById('contact');
  if (!footer || !contact) return;

  let releasing = false;
  let inZone = false;
  let touchY = 0;

  const isStatic = () => footer.classList.contains('is-static');
  const toBottom = () => {
    footer.scrollTop = footer.scrollHeight;
  };
  const atPageBottom = () => {
    const root = document.scrollingElement || document.documentElement;
    return window.scrollY + window.innerHeight >= root.scrollHeight - 1;
  };
  const wheelDelta = (e) => {
    if (e.deltaMode === 1) return e.deltaY * 16;
    if (e.deltaMode === 2) return e.deltaY * footer.clientHeight;
    return e.deltaY;
  };

  // sticky → static（見た目を維持して解除）
  // anchor: 'top' = 上端合わせ / 'bottom' = 下端合わせ
  const release = (extraDy = 0, anchor = 'top') => {
    if (isStatic() || releasing) return;
    releasing = true;
    const rect = footer.getBoundingClientRect();
    footer.classList.add('is-static');
    footer.scrollTop = footer.scrollHeight;
    void footer.offsetHeight;
    const next = footer.getBoundingClientRect();
    const delta = anchor === 'bottom' ? next.bottom - rect.bottom : next.top - rect.top;
    window.scrollBy(0, delta + extraDy);
    releasing = false;
  };

  const handleDelta = (e, dy) => {
    if (isStatic() || !inZone) return;
    e.preventDefault();

    const max = footer.scrollHeight - footer.clientHeight;
    const prev = footer.scrollTop;
    const next = Math.max(0, Math.min(max, prev + dy));
    footer.scrollTop = next;
    const rest = dy - (next - prev);

    if (next === 0 && dy < 0) release(rest, 'top');
    else if (rest) window.scrollBy(0, rest);
  };

  toBottom();

  footer.addEventListener('wheel', (e) => handleDelta(e, wheelDelta(e)), { passive: false });
  footer.addEventListener('touchstart', (e) => {
    touchY = e.touches[0].clientY;
  }, { passive: true });
  footer.addEventListener('touchmove', (e) => {
    const y = e.touches[0].clientY;
    const dy = touchY - y;
    touchY = y;
    handleDelta(e, dy);
  }, { passive: false });

  window.addEventListener('scroll', () => {
    if (releasing) return;

    if (isStatic()) {
      if (footer.getBoundingClientRect().top >= window.innerHeight) {
        footer.classList.remove('is-static');
        inZone = false;
        requestAnimationFrame(toBottom);
      }
      return;
    }

    const nextInZone = contact.getBoundingClientRect().top <= 0;
    if (nextInZone && !inZone) toBottom();
    inZone = nextInZone;

    // ページ最下部到達時点で static 化（下端の見え方を維持）
    if (inZone && atPageBottom()) release(0, 'bottom');
  }, { passive: true });
};


const contentAnimations = () => {
  differenceAnimation();
  digitalAnimation();
  footerAnimation();
  pageTopLInk();

  document.addEventListener('scroll', () => {
    document.body.classList.toggle('is-scrolled-top', window.scrollY <= 100);
  }, { passive: true });
};

export default contentAnimations();
